import { v4 as uuid } from "uuid";

export default class UUIDUtils {

    public static generateUUID(): string {
        return uuid();
    }
}
